import styled from 'styled-components'

import { Flex } from 'Components/UI/_Legacy'

import { LANDING_INLINE_PADDINGS, PY_BLUEPRINT } from 'Constants/Landing'

export const Container = styled(Flex).attrs({
  mb: PY_BLUEPRINT,
})`
  width: 100%;
  justify-content: center;
  overflow: hidden;
`

export const Content = styled(Flex).attrs({
  flexDirection: ['column', 'column', 'row'],
  px: LANDING_INLINE_PADDINGS,
})`
  align-items: center;
  position: relative;
`

export const LeftContainer = styled(Flex).attrs({
  width: [1, 1, 60 / 118],
})``

export const ButtonWrapper = styled(Flex).attrs({
  mt: [7, 7, 9, 10],
})``

export const ImageHolder = styled(Flex).attrs({
  width: [1, 1, 58 / 118],
  mt: [26, 26, 40, 0],
  height: [210, 210, 390, 390, 294, 390],
})`
  position: relative;
  z-index: 2;
`

export const DotsContainer = styled(Flex).attrs({
  display: ['none', 'none', 'flex'],
})`
  z-index: 1;
  position: absolute;
  right: -32px;
  bottom: -32px;
`
